<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="equipment">Equipment</label>
                    <wj-combo-box
                        [(ngModel)]="target.equipment"
                        name="equipment"
                        id="equipment"
                        [itemsSource]="equipmentMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="fromJob">From Job</label>
                    <wj-combo-box
                        [(ngModel)]="target.fromJob"
                        name="fromJob"
                        id="fromJob"
                        [isRequired]="false"
                        [itemsSource]="jobMap2"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="forJob">For Job</label>
                    <wj-combo-box
                        [(ngModel)]="target.forJob"
                        name="forJob"
                        id="forJob"
                        [isRequired]="false"
                        [itemsSource]="jobMap2"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="requestedByHrRef">Requested By</label>
                    <wj-combo-box
                        [(ngModel)]="target.requestedByHrRef"
                        name="requestedByHrRef"
                        id="requestedByHrRef"
                        [isRequired]="false"
                        [itemsSource]="userMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="transferDate">Transfer Needed</label>
                    <wj-input-date
                        [(ngModel)]="target.transferDate"
                        name="transferDate"
                        id="transferDate"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="transferByHrRef">Transfer By</label>
                    <wj-combo-box
                        [(ngModel)]="target.transferByHrRef"
                        name="transferByHrRef"
                        id="transferByHrRef"
                        [isRequired]="false"
                        [itemsSource]="userMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
